import React from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title: 'More Than Just a Loan',
    item1: 'Help build',
    item2: 'a solid path to',
    item3: 'your financial well-being',
  },
  id: {
    title: 'Lebih Dari Sekadar Pinjaman',
    item1: 'Membantu membangun',
    item2: 'jalan yang kokoh menuju',
    item3: 'kesejahteraan finansial Anda',
  },
})

const MoreLoan = () => {
  const { t } = useResource(resource)
  const titleList = [t('item1'), t('item2'), t('item3')]
  return (
    <BannerBox>
      <div className="container">
        <Reveal animation={Animation.FadeIn}>
          <div className="left">
            <LazyLoad>
              <img className="banner" src={`/images/about/about-banner2.png`} alt="banner-product" />
            </LazyLoad>
          </div>
        </Reveal>
        <div className="right">
          <div className="title">{t('title')}</div>
          {titleList.map((item, index) => {
            return (
              <div key={index} className="subtitle">
                {item}
              </div>
            )
          })}
        </div>
      </div>
    </BannerBox>
  )
}

export default MoreLoan

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 36px;
    .container {
      position: relative;
      height: 612px;
      width: 100%;
      margin: 0 auto;
      background-image: url('/images/about/mobile-about-bg2.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;

      .left {
        .banner {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 283px;
          height: 317px;
        }
      }
      .right {
        position: absolute;
        top: 56px;
        left: 24px;
        text-align: center;
        padding: 0 24px;
        .title {
          font-size: 24px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          line-height: 28px;
          padding-bottom: 16px;
        }
        .subtitle {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 32px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1140px;
    margin: 160px auto 0;
    .container {
      position: relative;
      height: 359px;
      width: 100%;
      max-width: 1140px;
      margin: 0 auto;
      background-image: url('/images/about/about-bg2.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .left {
        width: 100%;
        .banner {
          position: absolute;
          left: -20px;
          bottom: 0;
          width: 376px;
          height: 421px;
        }
      }
      .right {
        position: absolute;
        left: 564px;
        width: 373px;
        .title {
          padding: 81px 0 24px;
          font-size: 36px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          line-height: 48px;
        }
        .subtitle {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 24px;
        }
      }
    }
  }
`
